import { removeValue } from 'app/utils/array';
import {
  createBaseAsyncHandlers,
  createFailAction,
  createStartAction,
  createSuccessAction,
  initialState,
  makeDataUpdater,
} from 'app/api/redux-util/async-helpers';
import { createReducer } from 'app/api/redux-util/general-helpers';
import { combineReducers } from 'redux';

export function createListReducer({ get, add, del, listName, itemName }) {
  function updateOnDelete(state, action) {
    return {
      ...state,
      items: removeValue(state.items, action.data[0]),
    };
  }

  function updateOnAdd(state, action) {
    return {
      ...state,
      items: [action.data[itemName].guid, ...state.items],
    };
  }

  const baseHandlers = createBaseAsyncHandlers(get, data => ({
    items: data[listName].map(b => b.guid),
  }));

  const extraHandlers = {
    [createStartAction(del).type]: makeDataUpdater(updateOnDelete),
    [createSuccessAction(add).type]: makeDataUpdater(updateOnAdd),
  };

  return createReducer(initialState, baseHandlers, extraHandlers);
}

export function createEntryReducer({ get, add, update, listName, itemName }) {
  return function(state = {}, action) {
    if (action.type === createSuccessAction(get).type) {
      const newItems = action.data[listName].reduce((acc, cv) => {
        acc[cv.guid] = cv;
        return acc;
      }, {});

      return {
        ...state,
        ...newItems,
      };
    } else if (action.type === createStartAction(update).type) {
      const id = action.data[0];
      const newData = action.data[1];
      const oldData = state[id];
      return {
        ...state,
        [id]: {
          ...oldData,
          ...newData,
        },
      };
    } else if (action.type === createSuccessAction(add).type) {
      const item = action.data[itemName];
      return {
        ...state,
        [item.guid]: item,
      };
    }

    return state;
  };
}

export function createStatusReducer(key) {
  const handlers = {
    [createStartAction(key).type]: (state, action) => {
      return [...state, action.data[0]];
    },
    [createSuccessAction(key).type]: (state, action) => {
      return removeValue(state, action.args[0]);
    },
    [createFailAction(key).type]: (state, action) => {
      return removeValue(state, action.args[0]);
    },
  };

  return createReducer([], handlers);
}

export function createPendingReducer({ add, del, update }) {
  return combineReducers({
    add: createStatusReducer(add),
    del: createStatusReducer(del),
    update: createStatusReducer(update),
  });
}



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/userdata/utils/reducer-parts.js